import { Link } from "@tanstack/react-router";
import { QorumLogo } from "@/components/brand/QorumLogo";

type Props = {
  backHref?: string;
  backLabel?: string;
};

export function UtilityTopbar({ backHref = "/foyer", backLabel = "← Foyer" }: Props) {
  return (
    <header
      data-rp="utility-topbar"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px 32px",
        borderBottom: "0.5px solid var(--stone-mid)",
        background: "transparent",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <Link
        to="/"
        style={{ textDecoration: "none", display: "inline-flex", alignItems: "center" }}
      >
        <QorumLogo size="sm" />
      </Link>
      <a
        href={backHref}
        data-rp="utility-topbar-back"
        style={{
          fontFamily: '"DM Mono", monospace',
          fontSize: 11,
          letterSpacing: "2px",
          textTransform: "uppercase",
          color: "var(--charcoal)",
          textDecoration: "none",
          transition: "color 120ms",
          padding: "10px 0",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--leather)")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--charcoal)")}
      >
        {backLabel}
      </a>
    </header>
  );
}
